// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import FilteredConfigurableState from "@store/Framework/Store/Store/Data/FilteredConfigurable/FilteredConfigurableState";
import { Draft } from "immer";

const initialState: FilteredConfigurableState = {
    products: {},
};

const actions = {
    "Store/Data/FilteredConfigurable/SetFilteredConfigurable": (
        draft: Draft<FilteredConfigurableState>,
        action: {
            filteredConfigurable: {
                id: string;
                maxBtu: string;
                currentBtu: string;
                voltage: string;
                availability: { [key: string]: string } | undefined;
                hasIncompatibleSpecialUnitRestriction?: boolean;
                specialUnitRestrictionMessageKey?: string;
                specialUnitRestrictionBySectionOptionId?: SafeDictionary<boolean>;
            };
        },
    ) => {
        draft.products[action.filteredConfigurable.id] = {
            maxBtu: action.filteredConfigurable.maxBtu,
            currentBtu: action.filteredConfigurable.currentBtu,
            voltage: action.filteredConfigurable.voltage,
            availability: action.filteredConfigurable.availability,
            hasIncompatibleSpecialUnitRestriction: action.filteredConfigurable.hasIncompatibleSpecialUnitRestriction,
            specialUnitRestrictionMessageKey: action.filteredConfigurable.specialUnitRestrictionMessageKey,
            specialUnitRestrictionBySectionOptionId: action.filteredConfigurable.specialUnitRestrictionBySectionOptionId,
        };
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreFilteredConfigurableActions = Parameters<typeof reducer>[1];
export default reducer;
